import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { exchangeSession } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Sparkles } from "lucide-react";
import { useRef } from "react";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [error, setError] = useState(null);
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/");
      return;
    }
    const sessionId = match[1];

    exchangeSession(sessionId)
      .then((u) => {
        setUser(u);
        window.history.replaceState({}, "", "/dashboard");
        navigate("/dashboard", { replace: true, state: { user: u } });
      })
      .catch((e) => {
        console.error(e);
        setError("Impossible de vous connecter. Réessayez.");
        setTimeout(() => navigate("/"), 2500);
      });
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#080A11]">
      <div className="flex flex-col items-center gap-4">
        <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-violet-500 to-blue-500 flex items-center justify-center animate-pulse shadow-2xl shadow-violet-500/30">
          <Sparkles className="w-6 h-6 text-white" />
        </div>
        <p className="text-slate-400 text-sm" data-testid="auth-callback-status">
          {error ? error : "Connexion en cours..."}
        </p>
      </div>
    </div>
  );
}
